import { useState } from "react";
import { X, CheckCircle } from "lucide-react";

export default function ApproveModal({ open, onClose, onApprove, productName }) {
  const [notes, setNotes] = useState("");

  if (!open) return null;

  const handleClose = () => {
    setNotes("");
    onClose();
  };

  const handleApprove = () => {
    onApprove(notes.trim());
    setNotes("");
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 440 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: "#e0f7f4", border: "1.5px solid #A4E5E0", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <CheckCircle size={17} color="#0C6170" />
            </div>
            <div style={{ fontFamily: "'Google Sans Flex',sans-serif", fontWeight: 700, fontSize: 17, color: "#062830" }}>Approve Review</div>
          </div>
          <button className="btn btn-g btn-xs" onClick={handleClose}><X size={14} /></button>
        </div>
        
        <div style={{ fontSize: 13.5, color: "#0C6170", marginBottom: 14 }}>
          You are approving the submission for <strong style={{ color: "#062830" }}>{productName}</strong>. 
          Provide optional review notes below:
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: "#0C6170", marginBottom: 6, display: "block", textTransform: "uppercase", letterSpacing: ".07em" }}>
            Review Notes
          </label>
          <textarea
            className="inp"
            rows={4}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Enter review notes (optional)..."
            style={{ resize: "vertical" }}
          />
        </div>

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="btn btn-g btn-sm" onClick={handleClose}>Cancel</button>
          <button 
            className="btn btn-p btn-sm" 
            onClick={handleApprove}
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  );
}
